import Render from '@Views/root/main.html'
import {Component, Vue} from 'vue-property-decorator'
import {Header, Navigation} from '@Components/index'
import {Connection, Queue} from '@Models/index'
import {NotificationType, PackType, Profile} from '@Enums/index'
import {breadcrumb, notif, patient, popIn, purchase, user} from '@Store/modules'
import {INotification, IPopin, IPopinAction, IUser} from '@Store/types'
import {StorageHelper} from '@Helpers/storage'
import {EnumsHelper} from "@Helpers/enums"
import {RfeHelper} from "@Helpers/rfe"
import axios from "axios";

@Render
@Component({
	components: {
		'navigation': Navigation,
		'headeur': Header
	}
})
export class Main extends Vue {

	// TODO Cheikh: tu décommentes les 2 dates suivantes en les ajustant selon tes tests et tu commentes les 2 dates suivantes
	// public static readonly limitDate: Date = new Date(2024, 9, 7, 0, 0, 0, 0)
	// private static readonly endDate: Date = new Date(2024, 9, 12, 0, 0, 0, 0)
	public static readonly limitDate: Date = new Date(2024, 10, 1, 0, 0, 0, 0)
	private static readonly endDate: Date = new Date(2025, 0, 1, 0, 0, 0, 0)

	get hasAside(): boolean {
		return breadcrumb.hasAside
	}
	get user(): IUser {
		return user.user
	}
	get communicationKey(): string {
		return `communication_key_${user.currentUser.id}`
	}
	get subscriptionKey(): string {
		return `subscription_key_${user.currentUser.id}`
	}
	get webhookKey(): string {
		return `webhook_key_${user.currentUser.id}`
	}
	get canShowCommunication(): boolean {
		let isCommunicationHidden = !!StorageHelper.get(this.communicationKey, false);
		let now = new Date();
		return !isCommunicationHidden && now < Main.limitDate;
	}

	get canShowCommunicationRfe(): boolean {
		return this.user.can_show_communication_rfe && !this.user.isSubscriptionRequired;
	}

	get canShowDefaultOfficeRfe(): boolean {
		return RfeHelper.shouldChooseDefaultOffice();
	}
	get canShowSubscription(): boolean {
		switch (this.user.license) {
			case 99999:
				return this.user.isSubscriptionRequired;
			default:
				return false
		}

	}

	mounted() {
		patient.loadBackup()
		.then(result => {
			if (Object.keys(result).length === 0) return

			let message:string = this.$t('vm.root.main.load-backup').toString()
			let notification:INotification = { message: message, actions: [], delay: 5000, canClose: true }
			notif.info(notification)
		})
		Queue.getInstance().addListener(this.callback)
		Connection.getInstance().addListener(this.callback)

		window.addEventListener('online',  this.updateOnlineStatus)
		window.addEventListener('offline', this.updateOnlineStatus)

		if (!this.user || this.user.profile !== Profile.Main)
			return

		if (this.canShowCommunicationRfe) {
			this.communicationRfe()
		} else if (this.canShowDefaultOfficeRfe) {
			RfeHelper.chooseDefaultOffice()
		}

		if (this.canShowCommunication) {
			this.communication()
		} else if (this.canShowSubscription) {
			this.subscription()
		}
	}

	beforeDestroy() {
		Queue.getInstance().removeListener(this.callback)
		Connection.getInstance().removeListener(this.callback)

		window.removeEventListener('online',  this.updateOnlineStatus)
		window.removeEventListener('offline', this.updateOnlineStatus)
	}

	private updateOnlineStatus() {
		Connection.getInstance().state = window.navigator.onLine
	}

	private callback(notification: INotification, type: NotificationType): void {
		notif.notif({notification: notification, type: type})
	}

	private communicationRfe(): void {

		let action: IPopinAction = {
			label: this.$i18n.t('vm.root.home.communication-rfe.action.label').toString(),
			title: this.$i18n.t('vm.root.home.communication-rfe.action.title').toString(),
			condition: ({ choice, refuseReason }: { choice: string, refuseReason: string }) => {
				if (choice === "1") return true;
				if (choice === "0") return refuseReason.trim().length > 0;
				return false;
			},
			callback: async ({choice, refuseReason, substituteIds}: {user: IUser, choice: string, refuseReason: string, substituteIds: string[]}, updateLoading: (loading: boolean) => void) => {
				try {
					updateLoading(true)
					await user.updateRfeChoice({ choice, reason: refuseReason, substituteIds })
					let notification: INotification = {message: this.$i18n.t('vm.root.home.communication-rfe.message.success').toString(), actions:[], delay: 5000, canClose: true}
					notif.success(notification)
					if(choice == "1"){
						if (!this.checkRfeInfos()) {
							await this.$router.push({ name: 'user-informations' });
						}
					}

				} catch (err) {
					let notification: INotification = {message: this.$i18n.t('vm.root.home.communication-rfe.message.failed').toString(), actions:[], delay: 5000, canClose: true}
					notif.error(notification)
				} finally {
					await user.reloadUser()
					updateLoading(false)
				}
			},
			stayOpen: false
		}
		let communicationRfe: IPopin = {
			title: this.$i18n.t('vm.root.home.communication-rfe.title').toString(),
			content: {component: 'popin-communication-rfe'},
			action,
			isWide: true,
			isWizard: true,
			options: {
				choice: '',
				refuseReason: '',
				substituteIds: []
			},
			cancelAction: this.noChoiceAction2,
			cancelLabel: this.$i18n.t('vm.root.home.communication-rfe.no-choice').toString()
		}

		popIn.info(communicationRfe)
	}

	 private communication(): void {

		 let communication: IPopin = {
			 title: this.$i18n.t('vm.root.home.communication.title').toString(),
			 content: {component: 'popin-communication'},
			 action: null,
			 isWide: true,
			 options: {user : this.user, storageKey : this.communicationKey},
			 cancelLabel: this.$i18n.t('general.close.text').toString()
		 }

		 popIn.info(communication)
	 }

	 private subscription(): void {
		 let now = new Date();
		let action: IPopinAction = {
			label: this.$i18n.t('vm.root.home.subscription.action.label').toString(),
			title: this.$i18n.t('vm.root.home.subscription.action.title').toString(),
			condition: ({choice, subscription, cgv}: {user: IUser, choice: string, subscription: string, cgv: boolean}) => {
				if (choice === 'choice-1') {
					return !!subscription
				}
				return choice === 'choice-2' && cgv
			},
			callback: ({choice, subscription}: {user: IUser, choice: string, subscription: string}) => {
				if (choice === 'choice-1') {
					return this.applyChoice1(parseInt(subscription))
				}

				if (choice === 'choice-2') {
					return this.applyChoice2()
				}
				return Promise.resolve()
			},
			stayOpen: false
		}
		 let subscription: IPopin = {
			 title: this.$i18n.t('vm.root.home.subscription.title').toString(),
			 content: {component: 'popin-subscription'},
			 action,
			 isWide: true,
			 options: {user : this.user, choice : '', subscription: '', cgv: false},
			 cantCancel: now > Main.endDate,
			 cancelAction: this.noChoiceAction,
			 cancelLabel: this.$i18n.t('vm.root.home.subscription.no-choice').toString()
		 }

		 popIn.info(subscription)
	 }

	 private applyChoice1(value: number): Promise<void> {
		 const payload = {
			 value,
			 type: EnumsHelper.packTypeToStripeMeta(PackType.Unlimited),
			 canApplyReferral: false,
			 referralCode : ''
		 }

		 return purchase.createCheckout(payload)
			 .then((url: string) => {
				 const now = new Date()
				 StorageHelper.set(this.webhookKey, now.toISOString());
				 window.location.href = url
				 return Promise.resolve()
			 })
			 .catch((error) => {
				 return Promise.reject(error)
			 })
	 }

	 private applyChoice2(): Promise<void> {
		 const email = this.user.email
		 const baseURL = 'https://confirm.matiscode.fr'
		 const provider: any = axios.create({baseURL})

		 provider.get('/leaved-client', {params: {email}})

		 return user.leave()
	 }

	private noChoiceAction2(): void {
		this.$emit('close')
	}


	private noChoiceAction(): void {
		let now = new Date()
		if (now < Main.endDate) {
			let middle = new Date(Main.endDate.getTime() - now.getTime())
			now.setTime(now.getTime() + middle.getTime() / 2)
		} else {
			now = Main.endDate
		}

		StorageHelper.set(this.subscriptionKey, `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`);
	 }
	 private checkRfeInfos(): boolean {
		let address = this.user && this.user.coordinates ? this.user.coordinates.address : null
		return !!this.user && !!this.user.coordinates.siren && !!this.user.coordinates.tva && !!this.user.coordinates.naf
			&& !!address && !!address.street && !!address.zipcode && !!address.city;
	 }
}
